import { createApp } from 'vue';
import App from './App.vue';
import { setupRouter } from './router';
import { setupStore } from './store';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import './styles/index.scss';
import 'element-plus/dist/index.css';

import '@/router/guard';

const req = require.context('./assets/icons', false, /\.svg$/);
const requireAll = (requireContext: any) =>
  requireContext.keys().map(requireContext);
requireAll(req);

const app = createApp(App);
setupStore(app);

setupRouter(app);
app.use(ElementPlus, {
  locale: zhCn,
});

app.mount('#app');
